import { ExternalLinkIcon, InfoIcon } from '@chakra-ui/icons'
import { Button, Flex, Text } from '@chakra-ui/react'

export const AuthenticatorInfo = () => (
  <Flex
    p={2}
    border="1px solid #cdcdcd"
    borderRadius={6}
    bg="white"
    w="100%"
    flexFlow="column"
    gap={2}>
    <Text textAlign="center" fontFamily="Open Sans" fontSize="sm" color="gray.600">
      <InfoIcon mr={1.5} />
      Having trouble verifying via text? Try using an authenticator app instead. If you don't have
      an authenticator app installed, we recommend Google Authenticator, but you can install any
      authenticator app.
    </Text>
    <Button
      size="sm"
      onClick={() =>
        window.open(
          'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
          '_blank',
        )
      }
      variant="link">
      Google Authenticator for Android
      <ExternalLinkIcon ml={1.5} />
    </Button>
    <Button
      size="sm"
      onClick={() =>
        window.open('https://apps.apple.com/us/app/google-authenticator/id388497605', '_blank')
      }
      variant="link">
      Google Authenticator for iOS
      <ExternalLinkIcon ml={1.5} />
    </Button>
  </Flex>
)
